import {
  FamilyOutlined,
  GlobeOutlined,
  LockOutlined,
  StudentOutlined,
} from "@toddle-edu/ds-icons";
import React from "react";

const ShareWithIconSvg = props => {
  const { type } = props;

  if (type == "student") {
    return <StudentOutlined {...props} />;
  } else if (type == "parent") {
    return <FamilyOutlined {...props} />;
  } else if (type == "everyone") {
    return <GlobeOutlined {...props} />;
  } else if (type == "private") {
    return <LockOutlined {...props} />;
  }

  return <GlobeOutlined {...props} />;
};

ShareWithIconSvg.defaultProps = {
  size: "x-small",
  variant: "default",
};

export default ShareWithIconSvg;
